"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeMarginLiquidationEvents = exports.subscribeMarginCallEvents = exports.subscribeMarginAccountBalanceSummaryStateEvents = exports.subscribeMarginAccountBalanceStateEvents = exports.requestMarginInstruments = exports.requestMarginAccount = exports.refreshMarginAccountInfo = exports.receiveSystemMarginEnabled = exports.receiveMarginKVPInfo = exports.receiveMarginInstruments = exports.receiveMarginAccountInfo = exports.preloadMarginData = exports.initMarginTrading = exports.getMaxTransferAmount = exports.getMarginProductsConfig = exports.getMarginKVP = exports.getMarginInstruments = exports.getMarginAccountInfo = exports.getAccountMarginBalances = exports.dismissMarginNotification = exports.UPDATE_MARGIN_BALANCES = exports.REQUEST_MARGIN_INSTRUMENTS = exports.REQUEST_MARGIN_BALANCES = exports.RECEIVE_SYSTEM_MARGIN_ENABLED = exports.RECEIVE_MAX_TRANSFER_AMOUNT = exports.RECEIVE_MARGIN_PRODUCT_CONFIGS = exports.RECEIVE_MARGIN_KVP_INFO = exports.RECEIVE_MARGIN_INSTRUMENTS = exports.RECEIVE_MARGIN_BALANCES = exports.RECEIVE_MARGIN_ACCOUNT_INFO = exports.DISMISS_MARGIN_NOTIFICATION = void 0;
var _apiActions = require("../../actions/apiActions");
var _snackbarActions = require("../../actions/snackbarActions");
var _userActions = require("../../actions/userActions");
var _selectors = require("../selectors");
var _marginHistoryActions = require("./marginHistoryActions");
var _MarginCallSubscriptionService = _interopRequireDefault(require("../services/MarginCallSubscriptionService"));
var _MarginAccountLiquidationSubscriptionService = _interopRequireDefault(require("../services/MarginAccountLiquidationSubscriptionService.js"));
var _MarginAccountBalanceSummaryStateSubscriptionService = _interopRequireDefault(require("../services/MarginAccountBalanceSummaryStateSubscriptionService.js"));
var _MarginAccountBalanceStateSubscriptionService = _interopRequireDefault(require("../services/MarginAccountBalanceStateSubscriptionService.js"));
var _orderHistoryActions = require("../../actions/orderHistoryActions");
var _marginNavNotificationActions = require("./marginNavNotificationActions.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var preloadMarginData = exports.preloadMarginData = function preloadMarginData(AccountId, OMSId) {
  return function (dispatch) {
    dispatch(getMarginAccountInfo(AccountId, OMSId));
    dispatch((0, _orderHistoryActions.getOpenOrders)(AccountId, OMSId));
    dispatch((0, _marginHistoryActions.getOpenPositions)(AccountId, OMSId));
    dispatch((0, _marginHistoryActions.getClosedPositions)(AccountId, OMSId));
    dispatch((0, _marginHistoryActions.subscribeToMarginPositionEvents)(AccountId));
    dispatch(subscribeMarginCallEvents(AccountId));
    dispatch(subscribeMarginLiquidationEvents(AccountId));
    dispatch(subscribeMarginAccountBalanceSummaryStateEvents(AccountId));
    dispatch(subscribeMarginAccountBalanceStateEvents(AccountId));
    dispatch(getAccountMarginBalances(AccountId));
  };
};

// Margin - 8.25.23
var requestMarginAccount = exports.requestMarginAccount = function requestMarginAccount() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var UserId, responseObj;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            UserId = getState().user.userInfo.UserId;
            _context.prev = 1;
            _context.next = 4;
            return dispatch((0, _apiActions.callAPI)('RequestMarginAccount', {}));
          case 4:
            responseObj = _context.sent;
            if (!(responseObj && responseObj.result == false)) {
              _context.next = 10;
              break;
            }
            dispatch((0, _snackbarActions.showSnack)({
              id: 'requestMarginAccountError',
              text: responseObj.errormsg,
              type: 'warning'
            }));
            return _context.abrupt("return", false);
          case 10:
            dispatch((0, _userActions.getUserInfo)(UserId));
            return _context.abrupt("return", true);
          case 12:
            _context.next = 19;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](1);
            console.error('requestMarginAccountError error: ', _context.t0);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'requestMarginAccountError',
              text: _context.t0.o,
              type: 'warning'
            }));
            return _context.abrupt("return", false);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 14]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getMarginInstruments = exports.getMarginInstruments = function getMarginInstruments(OMSId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch) {
      var instruments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            dispatch(requestMarginInstruments());
            _context2.next = 4;
            return dispatch((0, _apiActions.callAPI)('GetAllMarginInstrumentConfigs', {
              OMSId: OMSId
            }));
          case 4:
            instruments = _context2.sent;
            dispatch(receiveMarginInstruments(instruments));
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            console.error('GetMarginInstruments error: ', _context2.t0);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 8]]);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var REQUEST_MARGIN_INSTRUMENTS = exports.REQUEST_MARGIN_INSTRUMENTS = 'REQUEST_MARGIN_INSTRUMENTS';
var requestMarginInstruments = exports.requestMarginInstruments = function requestMarginInstruments() {
  return {
    type: REQUEST_MARGIN_INSTRUMENTS
  };
};
var RECEIVE_MARGIN_INSTRUMENTS = exports.RECEIVE_MARGIN_INSTRUMENTS = 'RECEIVE_MARGIN_INSTRUMENTS';
var receiveMarginInstruments = exports.receiveMarginInstruments = function receiveMarginInstruments(instruments) {
  return {
    type: RECEIVE_MARGIN_INSTRUMENTS,
    payload: instruments
  };
};
var REQUEST_MARGIN_BALANCES = exports.REQUEST_MARGIN_BALANCES = 'REQUEST_MARGIN_BALANCES';
var RECEIVE_MARGIN_BALANCES = exports.RECEIVE_MARGIN_BALANCES = 'RECEIVE_MARGIN_BALANCES';
var UPDATE_MARGIN_BALANCES = exports.UPDATE_MARGIN_BALANCES = 'UPDATE_MARGIN_BALANCES';
var getAccountMarginBalances = exports.getAccountMarginBalances = function getAccountMarginBalances(AccountId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch, getState) {
      var OMSId, HideSmallAmounts, responseObj;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            HideSmallAmounts = localStorage.getItem('hideMarginSmallAmounts') !== 'false';
            _context3.prev = 2;
            dispatch({
              type: REQUEST_MARGIN_BALANCES
            });
            _context3.next = 6;
            return dispatch((0, _apiActions.callAPI)('GetAccountMarginBalances', {
              OMSId: OMSId,
              AccountId: AccountId,
              HideSmallAmounts: HideSmallAmounts
            }));
          case 6:
            responseObj = _context3.sent;
            if (!responseObj) {
              _context3.next = 12;
              break;
            }
            dispatch({
              type: RECEIVE_MARGIN_BALANCES,
              payload: responseObj
            });
            return _context3.abrupt("return", true);
          case 12:
            dispatch((0, _snackbarActions.showSnack)({
              id: 'GetAccountMarginBalancesError',
              text: 'Get Account Margin Balances Error.',
              type: 'warning'
            }));
            return _context3.abrupt("return", false);
          case 14:
            _context3.next = 21;
            break;
          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](2);
            console.error('GetAccountMarginBalancesError error: ', _context3.t0);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'GetAccountMarginBalancesError',
              text: _context3.t0.o,
              type: 'warning'
            }));
            return _context3.abrupt("return", false);
          case 21:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 16]]);
    }));
    return function (_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var refreshMarginAccountInfo = exports.refreshMarginAccountInfo = function refreshMarginAccountInfo() {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var AccountId;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            AccountId = getState().margin.accountInfo.AccountId;
            dispatch(getMarginAccountInfo(AccountId));
            dispatch(getAccountMarginBalances(AccountId));
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var getMarginAccountInfo = exports.getMarginAccountInfo = function getMarginAccountInfo(AccountId) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch, getState) {
      var OMSId, responseObj;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            if (OMSId) {
              _context5.next = 3;
              break;
            }
            return _context5.abrupt("return");
          case 3:
            _context5.prev = 3;
            _context5.next = 6;
            return dispatch((0, _apiActions.callAPI)('GetMarginAccountInfo', {
              OMSId: OMSId,
              AccountId: AccountId
            }));
          case 6:
            responseObj = _context5.sent;
            if (!(responseObj && responseObj.result !== false)) {
              _context5.next = 12;
              break;
            }
            dispatch(receiveMarginAccountInfo(responseObj));
            return _context5.abrupt("return", true);
          case 12:
            console.error('getMarginAccountInfoError error: ', responseObj);
            return _context5.abrupt("return", false);
          case 14:
            _context5.next = 20;
            break;
          case 16:
            _context5.prev = 16;
            _context5.t0 = _context5["catch"](3);
            console.error('getMarginAccountInfoError error: ', _context5.t0);
            return _context5.abrupt("return", false);
          case 20:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[3, 16]]);
    }));
    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var RECEIVE_MARGIN_ACCOUNT_INFO = exports.RECEIVE_MARGIN_ACCOUNT_INFO = 'RECEIVE_MARGIN_ACCOUNT_INFO';
var receiveMarginAccountInfo = exports.receiveMarginAccountInfo = function receiveMarginAccountInfo(accountInfo) {
  return {
    type: RECEIVE_MARGIN_ACCOUNT_INFO,
    payload: accountInfo
  };
};
var marginCallNotificationId = 'MarginCall';
var marginCallStatus = {
  OPEN: 'Open'
};
var subscribeMarginCallEvents = exports.subscribeMarginCallEvents = function subscribeMarginCallEvents(AccountId) {
  return function (dispatch) {
    _MarginCallSubscriptionService["default"].subscribe(function (payload) {
      if (payload.AccountId === AccountId) {
        if (payload.MarginCallStatus === marginCallStatus.OPEN) {
          dispatch((0, _snackbarActions.showSnack)({
            id: marginCallNotificationId,
            text: 'Margin account at risk. Your maintenance margin threshold has been reached',
            textVars: {
              ns: 'margin'
            },
            type: 'warning'
          }));
          dispatch((0, _marginNavNotificationActions.addMarginNavNotification)());
        }
      }
    });
  };
};
var subscribeMarginAccountBalanceSummaryStateEvents = exports.subscribeMarginAccountBalanceSummaryStateEvents = function subscribeMarginAccountBalanceSummaryStateEvents(AccountId) {
  return function (dispatch) {
    _MarginAccountBalanceSummaryStateSubscriptionService["default"].subscribe(function (payload) {
      if (payload.AccountId === AccountId) {
        dispatch(receiveMarginAccountInfo(payload));
      }
    });
  };
};
var subscribeMarginAccountBalanceStateEvents = exports.subscribeMarginAccountBalanceStateEvents = function subscribeMarginAccountBalanceStateEvents(AccountId) {
  return function (dispatch) {
    _MarginAccountBalanceStateSubscriptionService["default"].subscribe(function (payload) {
      var _payload$;
      if (((_payload$ = payload[0]) === null || _payload$ === void 0 ? void 0 : _payload$.AccountId) === AccountId) {
        dispatch({
          type: UPDATE_MARGIN_BALANCES,
          payload: payload
        });
      }
    });
  };
};
var marginLiquidationNotificationIdBase = 'MarginPositionLiquidation';
var marginLiquidationStatus = {
  NEW: 'New'
};
var subscribeMarginLiquidationEvents = exports.subscribeMarginLiquidationEvents = function subscribeMarginLiquidationEvents(AccountId) {
  return function (dispatch, getState) {
    _MarginAccountLiquidationSubscriptionService["default"].subscribe(function (payload) {
      if (payload.AccountId === AccountId) {
        var _getState$apexCore$in;
        var instrumentSymbol = (_getState$apexCore$in = getState().apexCore.instrument.instruments.find(function (i) {
          return i.InstrumentId === payload.InstrumentId;
        })) === null || _getState$apexCore$in === void 0 ? void 0 : _getState$apexCore$in.Symbol;
        if (payload.LiquidationStage === marginLiquidationStatus.NEW) {
          dispatch((0, _snackbarActions.showSnack)({
            id: marginLiquidationNotificationIdBase,
            text: 'Your {{symbol}} {{positionType}} position has been liquidated.',
            textVars: {
              ns: 'margin',
              symbol: instrumentSymbol,
              positionType: payload.MarginPositionType,
              PositionId: payload.PositionId
            },
            type: 'warning'
          }));
          dispatch((0, _marginNavNotificationActions.addMarginNavNotification)());
        }
      }
    });
  };
};
var RECEIVE_MARGIN_KVP_INFO = exports.RECEIVE_MARGIN_KVP_INFO = 'RECEIVE_MARGIN_KVP_INFO';
var receiveMarginKVPInfo = exports.receiveMarginKVPInfo = function receiveMarginKVPInfo(marginKVPInfo) {
  return {
    type: RECEIVE_MARGIN_KVP_INFO,
    payload: marginKVPInfo
  };
};
var getMarginKVP = exports.getMarginKVP = function getMarginKVP() {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch) {
      var marginVL, minDepositValue, payload;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return dispatch((0, _apiActions.callAPI)('GetGeneralKVP', {
              Key: 'MarginVerificationLevels'
            }));
          case 3:
            marginVL = _context6.sent;
            _context6.next = 6;
            return dispatch((0, _apiActions.callAPI)('GetGeneralKVP', {
              Key: 'MarginMinimumAccountValue'
            }));
          case 6:
            minDepositValue = _context6.sent;
            payload = {
              marginVerificationLevels: marginVL.Value || '',
              minDepositValue: minDepositValue.Value || 0
            };
            dispatch(receiveMarginKVPInfo(payload));
            _context6.next = 15;
            break;
          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6["catch"](0);
            console.error('getMarginKVP error: ', _context6.t0);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'getMarginKVPError',
              text: _context6.t0.o,
              type: 'warning'
            }));
          case 15:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[0, 11]]);
    }));
    return function (_x10) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var RECEIVE_SYSTEM_MARGIN_ENABLED = exports.RECEIVE_SYSTEM_MARGIN_ENABLED = 'RECEIVE_SYSTEM_MARGIN_ENABLED';
var receiveSystemMarginEnabled = exports.receiveSystemMarginEnabled = function receiveSystemMarginEnabled(systemMarginEnabled) {
  return {
    type: RECEIVE_SYSTEM_MARGIN_ENABLED,
    payload: {
      systemMarginEnabled: systemMarginEnabled
    }
  };
};
var initMarginTrading = exports.initMarginTrading = function initMarginTrading(systemMarginEnabled) {
  return function (dispatch) {
    dispatch(receiveSystemMarginEnabled(systemMarginEnabled));
    dispatch(getMarginKVP());
  };
};
var RECEIVE_MARGIN_PRODUCT_CONFIGS = exports.RECEIVE_MARGIN_PRODUCT_CONFIGS = 'RECEIVE_MARGIN_PRODUCT_CONFIGS';
var getMarginProductsConfig = exports.getMarginProductsConfig = function getMarginProductsConfig() {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState) {
      var OMSId, res;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            _context7.prev = 1;
            _context7.next = 4;
            return dispatch((0, _apiActions.callAPI)('GetAllMarginProductConfigs', {
              OMSId: OMSId
            }));
          case 4:
            res = _context7.sent;
            dispatch({
              type: RECEIVE_MARGIN_PRODUCT_CONFIGS,
              payload: res
            });
            _context7.next = 11;
            break;
          case 8:
            _context7.prev = 8;
            _context7.t0 = _context7["catch"](1);
            console.error('GetMarginProductsConfig error: ', _context7.t0);
          case 11:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[1, 8]]);
    }));
    return function (_x11, _x12) {
      return _ref7.apply(this, arguments);
    };
  }();
};

/**
 * Loads the MaxAmount available to tranfer from the margin acccount.
 *
 * @param {number} productId Product ID to get the MaxTransferAmount for.
 * @returns {Promise<{ MaxAmount: number; IndexPrice: number }>}
 */
var getMaxTransferAmount = exports.getMaxTransferAmount = function getMaxTransferAmount(productId) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(dispatch, getState) {
      var OMSId, marginAccount, res;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            marginAccount = (0, _selectors.marginAccountSelector)(getState());
            if (!marginAccount) {
              _context8.next = 14;
              break;
            }
            _context8.prev = 3;
            _context8.next = 6;
            return dispatch((0, _apiActions.callAPI)('GetMaxTransferAmount', {
              OMSId: OMSId,
              AccountId: marginAccount.AccountId,
              ProductId: productId
            }));
          case 6:
            res = _context8.sent;
            dispatch({
              type: RECEIVE_MAX_TRANSFER_AMOUNT,
              payload: _objectSpread({
                productId: productId
              }, res)
            });
            return _context8.abrupt("return", res);
          case 11:
            _context8.prev = 11;
            _context8.t0 = _context8["catch"](3);
            console.error('GetMaxTransferAmount error: ', _context8.t0);
          case 14:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[3, 11]]);
    }));
    return function (_x13, _x14) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var RECEIVE_MAX_TRANSFER_AMOUNT = exports.RECEIVE_MAX_TRANSFER_AMOUNT = 'RECEIVE_MAX_TRANSFER_AMOUNT';
var DISMISS_MARGIN_NOTIFICATION = exports.DISMISS_MARGIN_NOTIFICATION = 'DISMISS_MARGIN_NOTIFICATION';
var dismissMarginNotification = exports.dismissMarginNotification = function dismissMarginNotification(id) {
  try {
    var marginNotifications = JSON.parse(localStorage.getItem('marginNotifications'));
    var updatedNotifications = marginNotifications.filter(function (notification) {
      return notification.id !== id;
    });
    localStorage.setItem('marginNotifications', JSON.stringify(updatedNotifications));
  } catch (error) {
    console.error('DismissMarginNotification error', error);
  }
  return {
    type: DISMISS_MARGIN_NOTIFICATION,
    payload: id
  };
};